import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../hooks/useAuth';

export const AuthGuard = ({ children }: { children: ReactElement }) => {
  const { authState } = useAuth();

  if (authState === 'IDLE') {
    return (
      <Box>
        <LinearProgress />
        <Box p={2}>
          <Typography variant="body2">起動中...</Typography>
        </Box>
      </Box>
    );
  }

  if (authState === 'UNAUTHENTICATED') {
    return <Navigate to="/login" replace />;
  }

  return children;
};
